import { z } from 'zod';

export const intercomEventSchema = z.discriminatedUnion('event', [
  z.object({
    event: z.literal('update-collection'),
  }),
  z.object({
    event: z.literal('clear-all-device-session'),
    data: z.object({
      userId: z.number(),
    }),
  }),
  z.object({
    event: z.literal('clear-all-device-session-success'),
    data: z.object({ userId: z.number() }),
  }),
  z.object({
    event: z.literal('clear-all-device-session-failed'),
    data: z.object({ userId: z.number() }),
  }),
  z.object({
    event: z.literal('join-group'),
  }),
  z.object({
    event: z.literal('update-enter-as-submit'),
    data: z.object({
      value: z.boolean(),
    }),
  }),
  z.object({
    event: z.literal('auth-credential-in-use'),
    data: z
      .object({
        userId: z.number(),
      })
      .optional(),
  }),
  z.object({
    event: z.literal('update-auth-credentials'),
  }),
  z.object({
    event: z.literal('leave-session'),
    data: z.object({
      type: z.enum(['group', 'user', 'session']),
      id: z.number(),
    }),
  }),
]);

export type IntercomEvent = z.infer<typeof intercomEventSchema>;
